import styled from 'styled-components';
import { ChipStyleMixin } from 'shared/styles';

export const ViewContactContainer = styled.div`
  display: flex;
  padding: 24px;
  height: calc(100vh - 60px);
`;

export const SummaryPane = styled.div`
  display: flex;
  flex-direction: column;
  width: 350px;
  background: #f4f7f9;
  box-shadow: 0px 2px 16px rgba(18, 52, 77, 0.1);
  border-radius: 4px;

  .error-text {
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: #6f7c87;
  }
  .empty-state-title {
    color: #6f7c87;
    font-size: 13px;
  }
  .empty-state-icon {
    width: 130px;
  }
`;

export const ContactDetailField = styled.div`
  :not(:last-child) {
    margin-bottom: 24px;
  }
  div.head-title {
    font-size: 16px;
    display: flex;
    align-items: center;
    gap: 24px;
    .underline {
      border-bottom: 3px solid #2c5cc5;
      color: #2c5cc5;
      cursor: pointer;
    }
    .tab-option {
      border-bottom: 3px solid transparent;
      cursor: pointer;
      color: #465967;
    }
  }
  div.key {
    font-size: 14px;
    color: var(--color-smoke-700);
    word-break: break-word;
    :not(:last-child) {
      margin-bottom: 8px;
    }
  }
  div.value {
    font-weight: 600;
    font-size: 14px;
    color: var(--color-elephant-900);
    word-break: break-word;
  }
  div.list {
    display: flex;
    flex-wrap: wrap;
    div.item {
      cursor: pointer;
      margin: 0 12px 12px 0;
      font-weight: 500;
      font-size: 12px;
      color: #000000;
      padding: 8px 12px;
      background: #ffffff;
      border: 1px solid #ededed;
      border-radius: 23px;
      width: fit-content;
    }
  }
`;

export const ContactDetailsTable = styled.div`
  flex: 1;
  overflow: auto;
  border-bottom: 1px solid #ececec;
  padding: 10px 24px 24px;
`;

export const SentimentTagsTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
  overflow: auto;
  border-bottom: 1px solid #ececec;
  padding: 10px 24px 24px;

  .tag-heading {
    color: #465967;
    display: flex;
    justify-content: space-between;
  }
  .tag-heading-container {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    line-height: 20px;
    .trigger-child {
      padding-top: 4px;
    }
  }
  .icon-wrapper {
    padding-top: 2px;
  }

  .sentiment-type {
    ${ChipStyleMixin}
    border-radius: 4px;
    width: fit-content;
    font-weight: 600;
    &.positive {
      color: #00795b;
      background-color: #e0f5f1;
      border: 1px solid #b4e5da;
    }
    &.neutral {
      color: #db9815;
      background-color: #fef2e1;
      border: 1px solid #fddbb5;
    }
    &.negative {
      color: #e43538;
      background-color: #fde9e9;
      border: 1px solid #f9c7c7;
    }
  }
  .sentiment-tags {
    ${ChipStyleMixin}
    color: #12344d;
    background-color: #ffffff;
    border: 1px solid #cfd7df;
    border-radius: 4px;
    width: fit-content;
    max-width: 100%;
    word-break: break-word;
  }

  .sentiment-tag-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 20px;
    overflow: auto;
    position: relative;
  }

  .sentiment-tags-container {
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
  }

  .sentiment-container {
    display: flex;
    flex-direction: column;
  }

  .sentiment-heading {
    color: #475867;
    font-size: 12px;
    font-weight: 600;
    position: sticky;
    top: 0;
    background: #f5f7f9;
    padding-bottom: 6px;
  }
  .topics-text {
    font-size: 16px;
  }
  .tag-edit-button {
    padding: 4px 8px;
    width: 40px;
  }
  .divider {
    border: 1px solid #ebeff3;
    margin: 18px 0px;
    display: inline-block;
    width: 100%;
    height: 0;
  }
`;

export const SentimentTableFooter = styled.div`
  .sentiment-footer {
    /* position: absolute;
    bottom: 0; */
    padding: 20px;
  }
  .poweredby-text {
    /* margin-left: 16px; */
    text-align: center;
    .icon {
      margin-right: 2px;
    }
    font-size: 14px;
    color: #475867;
    display: flex;
    align-items: center;
    justify-content: center;
    .beta-tag {
      ${ChipStyleMixin}
      background: #fef1e1;
      color: #c13e1b;
      border: 1px solid #fddbb5;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 600;
      margin-left: 8px;
    }
  }
`;

export const FixedContainer = styled.div<{ pd?: string }>`
  padding: ${({ pd }) => pd || '24px 24px 8px 24px'};
`;

export const SentimentEditContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  overflow: auto;
  padding: 24px;
  .edit-drawer-footer {
    border-top: 0.5px solid #ebeff3;
    width: 100%;
    padding: 16px 24px;
    right: 0px;
    position: absolute;
    bottom: 0;
    background: #f5f7f9;
    display: flex;
    justify-content: flex-end;
    gap: 10px;

    button {
      height: 32px;
      line-height: 1.3;
      padding: 0px 12px;
      width: fit-content;
    }
  }
  .svg-wrapper {
    display: none;
  }

  div[id='dropdownField container'] {
    ${({ isError }) => (isError ? '' : 'border-color:transparent')}
  }
  .tag-container-wrapper {
    overflow: auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: flex-start;
    padding-bottom: 20px;
    flex: 1;
    position: relative;
  }

  .topic-tags-container {
    border: 1px solid #ebeff3;
    border-radius: 4px;
    padding: 10px;
    width: 100%;
  }
  .container-heading {
    font-size: 14px;
    font-weight: 600;
    position: sticky;
    top: 0px;
    background: #fff;
    z-index: 100;
    padding-bottom: 4px;
    & + div {
      margin-top: 8px;
    }
  }
  .dot-positive {
    height: 10px;
    width: 10px;
    background-color: #009a79;
    border-radius: 50%;
    display: inline-block;
    margin-right: 8px;
  }
  .dot-neutral {
    height: 10px;
    width: 10px;
    background-color: #f8ab59;
    border-radius: 50%;
    display: inline-block;
    margin-right: 8px;
  }
  .dot-negative {
    height: 10px;
    width: 10px;
    background-color: #e43538;
    border-radius: 50%;
    display: inline-block;
    margin-right: 8px;
  }
  .topics-text {
    font-size: 14px;
    font-weight: 600;
    color: #465967;
  }
  .edit-sentiment-text {
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
  }

  .edit-sentiment-content {
    flex: 1;
    max-height: calc(100% - 124px);
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .dropdown-label {
    font-size: 12px;
    font-weight: 600;
    color: '#465967';
    padding-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 4px;
    & > span {
      display: flex;
    }
  }
  .divider {
    border: 1px solid #ebeff3;
    display: inline-block;
    margin: 8px 0px;
    width: 100%;
    height: 0;
  }
`;
